import { render, staticRenderFns } from "./WeightCounter.vue?vue&type=template&id=3ce0c235&scoped=true&"
import script from "./WeightCounter.vue?vue&type=script&lang=ts&"
export * from "./WeightCounter.vue?vue&type=script&lang=ts&"
import style0 from "./WeightCounter.vue?vue&type=style&index=0&id=3ce0c235&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce0c235",
  null
  
)

export default component.exports